// modules/RadioButtonGroupField.jsx
import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";

const RadioButtonGroupField = ({
  module,
  value,
  isEditable,
  onChange,
  fieldKey,
}) => {
  return (
    <FormControl
      component="fieldset"
      margin="normal"
      required={module.required}
      disabled={!isEditable}
    >
      <FormLabel component="legend">{module.label}</FormLabel>
      <RadioGroup
        value={value || ""}
        onChange={(e) => onChange(fieldKey, e.target.value)}
      >
        {module.options.map((option, idx) => (
          <FormControlLabel
            key={idx}
            value={option}
            control={<Radio />}
            label={option}
          />
        ))}
      </RadioGroup>
      {module.required && !value && (
        <FormHelperText error>Please select an option</FormHelperText>
      )}
    </FormControl>
  );
};

export default RadioButtonGroupField;
